export { KioskProLockScreen } from './kiosk-pro-lock-screen';
